import classNames from 'classnames';
import { Link } from 'gatsby';
import { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import { getBuildDomainForBuildType } from 'src/enums/build/build-domain';
import type { ClubInformation } from 'src/enums/club-information';
import { clubNameDependingOnBuildTypeAndLanguage } from 'src/helpers/club-helper';
import { getAbsoluteClubPagePath, getClubPagePath } from 'src/helpers/navigation-helper';

import Location from '../../icons/location';

import * as styles from './club-search-link.module.scss';

type ClubSearchLinkProps = {
  className?: string;
  club: ClubInformation;
  isOpen?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  optionId?: string;
  isActive?: boolean;
  onMouseEnter?: () => void;
};

export const ClubSearchLink = ({
  className,
  club,
  isOpen,
  onClick,
  optionId,
  isActive,
  onMouseEnter,
}: ClubSearchLinkProps) => {
  const { language, buildType } = use(SiteContext);
  const clubName = clubNameDependingOnBuildTypeAndLanguage(club.clubName, buildType, language);
  const linkClassName = classNames(styles.link, isOpen === true && styles.open, className);

  return getBuildDomainForBuildType(club.buildType) === getBuildDomainForBuildType(buildType) ? (
    <Link
      to={getClubPagePath('', club.siteId, language)}
      className={linkClassName}
      onClick={onClick}
      role="option"
      id={optionId}
      aria-selected={isActive}
      onMouseEnter={onMouseEnter}
    >
      <Location aria-hidden="true" />
      {clubName}
    </Link>
  ) : (
    <a
      href={getAbsoluteClubPagePath('', club.siteId, language)}
      className={linkClassName}
      onClick={onClick}
      role="option"
      id={optionId}
      aria-selected={isActive}
      onMouseEnter={onMouseEnter}
    >
      <Location aria-hidden="true" />
      {clubName}
    </a>
  );
};
